<template>
    <div style="color: red;font-size: 4rem">hello</div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue